module.exports = __webpack_public_path__ + "static/media/tg.5fe71154.jpeg";